// import Actions from '@/micro/store';
import VueCookies from 'vue-cookies'


// 权限判断
function checkArray(key) {
//   const arr = Actions.getGlobalState('permissions') || [];
  let rolePermissions = VueCookies.get('permissions');  
//   let permissions = rolePermissions ? rolePermissions.split(',') : []
  const arr = rolePermissions ? rolePermissions.split(',') : []
  //   如果key不是string，转成string
  console.log(arr)
  let tmpKey = key;
  if (typeof tmpKey !== 'string') {
    tmpKey = tmpKey.toString();
  }``
  const index = arr.indexOf(tmpKey);
  if (index > -1) {
    return true; // 有权限
  }
  return false; // 无权限
}

const permission = {
  inserted(el, binding) {
    const permissionVal = binding.value; // 获取到 v-permission的值
    if (permissionVal) {
      const hasPermission = checkArray(permissionVal);
      if (!hasPermission) {
        // 没有权限 移除Dom元素
        // eslint-disable-next-line no-unused-expressions
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  },
};

export default permission;
